import { render, staticRenderFns } from "./TeamStatComponent.vue?vue&type=template&id=252a3b0a&"
import script from "./TeamStatComponent.vue?vue&type=script&lang=js&"
export * from "./TeamStatComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeamStatComponent.vue?vue&type=style&index=0&id=252a3b0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports